import React from 'react';

function NoResult({ inputValue }) {
	return (
		<div className="noSearchResults">
			<p className="noSearchResults__p">Aucun résultat pour : {inputValue}</p>
		</div>
	);
}

export default NoResult;
